import {
    AgColDefsI,
    AgGridI,
  } from "../../../../../../shared/components/ag-grid/ag-grid.model";
import { AgSwitchComponent } from "../../../../../../shared/components/ag-grid/ag-switch/ag-switch.component";
import { RatingComponent } from "../../../../../../shared/components/ag-grid/rating/rating.component";
   import {DocumentTabHeader, GridName, HeaderName} from "../../../../../../shared/model/ag-grid-common-constant"
import { DocumentCellRendererComponent } from "../../../../../crm/companies/pages/company-info-tabs/document-cell-renderer/document-cell-renderer.component";
import { ActionsComponent } from "../../../../../import-documents/pages/duplicates-tab/actions/actions.component";
import {CompanyRendererComponent} from "../../../../../../shared/components/ag-grid/company-renderer/company-renderer.component"
import { IntentToBuyEditorComponent } from "../../../../../../shared/components/ag-grid/intent-to-buy-editor/intent-to-buy-editor.component";
import { IntentToBuyComponent } from "../../../../../../shared/components/ag-grid/intent-to-buy/intent-to-buy.component";
import { PriorityRendererComponent } from "../../../../../../shared/components/ag-grid/priority-renderer/priority-renderer.component";
  const PartNumberColumn: AgColDefsI = {
    headerName: HeaderName.PART_NUMBER,
    field: "partNumber",
    sortable: true,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    suppressMovable: false,
    uniqueName:'partNumber',
    lockPinned: true,
    lockPosition: "left",
    minWidth: 170,
    flex: 1,
    cellClass: "custom-part-number-cell",
    headerClass:"checkbox-pl-0",
    editable:false,
    cellRenderer: CompanyRendererComponent,
    cellRendererParams:{isCursorNotallowed:true,buttonVisible:true}
};



  const MfrColumn: AgColDefsI = {
    headerName: "MFR",
    field: "mfr",
    sortable: true,
    minWidth: 70,
    flex:1,
    cellClass: "custom-part-number-cell",
    editable:false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
  const OnHandColumn: AgColDefsI = {
    headerName: HeaderName.ONHAND,
    field: "onHand",
    sortable: true,
    minWidth: 110,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    editable:false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
  const AvailableColumn: AgColDefsI = {
    headerName: HeaderName.AVAILABLE,
    field: "available",
    sortable: true,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    editable:false,
    minWidth: 110,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
  const SPQColumn: AgColDefsI = {
    headerName: HeaderName.SPQ,
    field: "spq",
    flex:1,
    sortable: true,
    cellClass: "custom-part-number-cell" ,
    editable:false,
    minWidth: 80,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
  const ItemPkgColumn: AgColDefsI = {
    headerName: HeaderName.ITEM_PKG,
    field: "standardPackagingName",
    flex:1,
    sortable: true,
    cellClass: "custom-part-number-cell" ,
    editable:false,
    minWidth: 100,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};



  const RoHSColumn: AgColDefsI = {
    headerName: HeaderName.ROHS,
    field: "rohsName",
    sortable: true,
    flex:1,
    cellClass: "custom-part-number-cell",
    editable: false,
    minWidth: 100,
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
  };

const ROHSColumn: AgColDefsI = {
  headerName: HeaderName.ROHS,
  field: "rohsNames",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
editable:false,
minWidth: 100,
cellRenderer: CompanyRendererComponent,
cellRendererParams: (params: any) => {
  const list = (params.value || "").split(",").map(item => item.trim()).filter(item => item)
  const dataToShow = list.length > 2
    ? `${list.slice(0, 2).join(", ")} +${list.length - 2}`
    : list.join(", ") || "—";

  return {
    isTooltipEnabled: true,
    dataToShow, 
    tooltipData:  dataToShow !== "—" ? list.join(", ") : "",
  };
},
};





  const TesthouseColumn: AgColDefsI = {
    headerName: HeaderName.TESTHOUSE,
    field: "Testhouse",
    sortable: true,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    editable:false,
    minWidth: 130,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
  const VendorColumn: AgColDefsI = {
    headerName: HeaderName.VENDOR,
    field: "vendor",
    sortable: true,
    minWidth: 150,
    flex: 1,
    cellClass: "custom-part-number-cell",
    editable: false,
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
  };
const VendorContactColumn: AgColDefsI = {
  headerName: HeaderName.VENDOR_CONTACT,
  field: "vendorContact",
  sortable: true,
  flex: 1,
  cellClass: "custom-part-number-cell",
  editable: false,
  minWidth: 150,
  cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
  const StatusColumn: AgColDefsI = {
    headerName: HeaderName.STATUS,
    field: "Status",
    sortable: true,
    headerCheckboxSelection: true,
    checkboxSelection: true,
  //  headerClass: "position-initial",
    uniqueName:'status',
    suppressMovable: false,
    lockPinned: true,
    lockPosition: "left",
    minWidth: 100,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    headerClass:"checkbox-pl-0",
    // cellRenderer: DocumentCellRendererComponent
    editable:false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
    
};
  const MFRColumn: AgColDefsI = {
    headerName: "MFR",
    field: "mfr",
    sortable: true,
    cellClass: "custom-part-number-cell",
    minWidth: 150,
    flex:1,
    editable: false,
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",

  };
  const WONoColumn: AgColDefsI = {
    headerName: HeaderName.WO_NO,
    field: "WONo",
    sortable: true,
    minWidth: 100,
    flex: 1,
    cellClass: "custom-part-number-cell",
    editable: false,
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",

  };
  const NCMColumn: AgColDefsI = {
    headerName: HeaderName.NCM,
    field: "NCM",
    sortable: true,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    editable:false,
    minWidth: 80,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",

};
  const DateCodeColumn: AgColDefsI = {
    headerName: HeaderName.DATE_CODE,
    field: "dateCode",
    sortable: true,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    editable:false,
    minWidth: 140,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",

};
const SplitDateCodeColumn: AgColDefsI = {
  headerName: HeaderName.DATE_CODE,
  field: "dateCode",
  sortable: true,
  headerClass:"p-l-3rem",
  flex:1,
  cellClass: "custom-part-number-cell" ,
  editable:false,
  minWidth: 140,
  cellRenderer:DocumentCellRendererComponent,
  cellRendererParams:{splitDateCode:true}
};


const CPNColumn: AgColDefsI = {
  headerName: HeaderName.CPN,
  field: "cpn",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
  editable:false,
  minWidth: 150,
  cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",

};

const CustomerContactColumn: AgColDefsI = {
  headerName: HeaderName.COSTOMER_CONTACT,
  field: "contact",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
  editable:false,
  minWidth: 150,
  cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
const RecordTypeColumn: AgColDefsI = {
  headerName: HeaderName.RECORD_TYPE,
  field: "recordType",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
  editable:false,
  minWidth: 130,
  cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
const QtyAvailableColumn: AgColDefsI = {
  headerName: HeaderName.QTY_AVAILABLE,
  field: "qty",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
  editable:false,
  minWidth: 140,
  cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
const PriceColumn: AgColDefsI = {
  headerName: HeaderName.PRICE,
  field: "price",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
  editable:false,
  minWidth: 100,
  cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};

const ExpirationDateColumn: AgColDefsI = {
  headerName: HeaderName.EXPIRATION_DATE,
  field: "expirationDate",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
  editable:false,
  minWidth: 140,
  cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",

};
const RatingColumn: AgColDefsI = {
  headerName: HeaderName.RATING,
  field: "overallRating",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
  editable:false,
  cellRenderer: RatingComponent,
  minWidth: 120,
  cellRendererParams:{ratingClick:true}
};
const ActiveColumn: AgColDefsI = {
  headerName: HeaderName.ACTIVE,
  field: "active",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
  editable:false,
  minWidth: 140,
  cellRenderer: AgSwitchComponent,
  cellRendererParams:{agSwitchClick:true}
};

const ListDateColumn: AgColDefsI = {
  headerName: HeaderName.LIST_DATE,
  field: "listDate",
  headerCheckboxSelection: true,
  checkboxSelection: true,
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
  lockPinned: true,
  editable:false,
  suppressMovable: false,
  lockPosition: "left",
  minWidth: 180,
  headerClass:"checkbox-pl-0",
  uniqueName:'listDate',
  cellRenderer: params => {
    if (!params.value) return "&#8212;";
    const date = new Date(params.value);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }
};
const MPNAlternativeColumn: AgColDefsI = {
  headerName: HeaderName.MPN,
  field: "mpn",
  headerCheckboxSelection: true,
  checkboxSelection: true,
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
  lockPinned: true,
  editable:false,
  suppressMovable: false,
  lockPosition: "left",
  minWidth: 150,
  headerClass:"checkbox-pl-0",
  uniqueName:'alternativeMpn',
    cellRenderer: CompanyRendererComponent,
    cellRendererParams: {isCursor: true},
  // cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
const CompanyColumn: AgColDefsI = {
  headerName: HeaderName.COMPANY,
  field: "company",
  headerCheckboxSelection: true,
  checkboxSelection: true,
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
  lockPinned: true,
  editable:false,
  suppressMovable: false,
  lockPosition: "left",
  minWidth: 170,
  headerClass:"checkbox-pl-0",
  cellRenderer: CompanyRendererComponent,
  // cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
const StatusWithoutCheckboxColumn: AgColDefsI = {
  headerName: HeaderName.STATUS,
  field: "status",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell",
  editable: false,
  minWidth: 100,
  cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
};
const RequestColumn: AgColDefsI = {
  headerName: 'Request Date',
  field: "requestDate",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell",
  editable: false,
  minWidth: 140,
  cellRenderer: PriorityRendererComponent,
  cellRendererParams: { dateFormat: true },
};
const BuyTargetColumn: AgColDefsI = {
  headerName: 'Buy Target',
  field: "buyTarget",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell",
  editable: false,
  minWidth: 140,
  cellRenderer: params => params.value || params.value == 0 ? params.value : "<p>&#8212;</p>",

};
const TargetPriceColumn: AgColDefsI = {
  headerName: 'Target Price',
  field: "targetPrice",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell",
  editable: false,
  minWidth: 140,
  cellRenderer: params => params.value || params.value == 0 ? params.value : "<p>&#8212;</p>",

};
const ManufacturerColumn: AgColDefsI = {
  headerName: HeaderName.MANUFACTURER,
  field: "mfr",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell",
editable:false,
minWidth: 150,
cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
const DescriptionColumn: AgColDefsI = {
  headerName: HeaderName.DESCRIPTION,
  field: "description",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell",
editable:false,
minWidth: 130,
cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};

const PartStatusColumn: AgColDefsI = {
  headerName: HeaderName.PART_STATUS,
  field: "partStatusName",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell",
editable:false,
minWidth: 130,
cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};

const TagsColumn: AgColDefsI = {
  headerName: HeaderName.TAGS,
  field: "tagsName",
  sortable: true,
  flex: 1,
  cellClass: "custom-part-number-cell",
  editable: false,
  minWidth: 120,
  cellRenderer: CompanyRendererComponent,
  cellRendererParams: (params: any) => {
    const list = (params.value || "").split(",").map(item => item.trim()).filter(item => item)
    const dataToShow = list.length > 2
      ? `${list.slice(0, 2).join(", ")} +${list.length - 2}`
      : list.join(", ") || "—";

    return {
      isTooltipEnabled: true,
      dataToShow, 
      tooltipData:  dataToShow !== "—" ? list.join(", ") : "",
    };
  },
};

const DevicePkgColumn: AgColDefsI = {
  headerName: HeaderName.DEVICE_PKG,
  field: "devicePackageName",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell",
editable:false,
minWidth: 130,
cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};

const StandardPkgColumn: AgColDefsI = {
  headerName: HeaderName.STANDARD_PKG,
  field: "standardPackagingName",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell",
editable:false,
minWidth: 140,
cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
const NotesColumn: AgColDefsI = {
  headerName: HeaderName.NOTES,
  field: "notes",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell",
  editable: false,
  minWidth: 120,
  cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
};


const LinkColumn: AgColDefsI = {
  headerName: '',
  field: "link",
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell",
  editable:false,
  minWidth: 120,
  cellRenderer:ActionsComponent,
};



  const LotCodeColumn: AgColDefsI = {
    headerName: HeaderName.LOT_CODE,
    field: "lotCode",
    sortable: true,
    flex:1,
    cellClass: "custom-part-number-cell",
    editable: false,
    minWidth: 100,
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
  };



  const QtyColumn: AgColDefsI = {
    headerName: HeaderName.QTY,
    field: "qty",
    flex:1,
    sortable: true,
    cellClass: "custom-part-number-cell",
    editable: false,
    minWidth: 100,
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",

};

const  RohSColumn: AgColDefsI = {
  headerName: HeaderName.ROHS,
  field: "rohs",
  editable: false,
  sortable: true,
  minWidth: 100,
  cellClass: 'custom-part-number-cell',
  flex: 1,
  cellRenderer: CompanyRendererComponent,
  cellRendererParams: (params: any) => {
    const nameList = (params.value || [])
      .map((item: any) => item.name)
      .filter(Boolean);
  
    const dataToShow = nameList.length > 2
      ? `${nameList.slice(0, 2).join(", ")} +${nameList.length - 2}`
      : nameList.join(", ") || "—";
  
    return {
      isTooltipEnabled: true,
      dataToShow,
       tooltipData:  dataToShow !== "—" ? nameList.join(", ") : "",
    };
  }
}

const  RohsColumn: AgColDefsI = {
  headerName: HeaderName.ROHS,
  field: "rohs",
  editable: false,
  sortable: true,
  minWidth: 100,
  cellClass: "padding-left-38px",
  flex: 1,
  cellRenderer: CompanyRendererComponent,
  cellRendererParams: (params: any) => {
    const nameList = (params.value || [])
      .map((item: any) => item.name)
      .filter(Boolean);
  
    const dataToShow = nameList.length > 2
      ? `${nameList.slice(0, 2).join(", ")} +${nameList.length - 2}`
      : nameList.join(", ") || "—";
  
    return {
      isTooltipEnabled: true,
      dataToShow,
      tooltipData:  dataToShow !== "—" ? nameList.join(", ") : "",
    };
  }
}

  const ConditionColumn: AgColDefsI = {
    headerName: HeaderName.CONDITION,
    field: "condition",
    flex:1,
    sortable: true,
    cellClass: "custom-part-number-cell",
    editable: false,
    minWidth: 110,
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
  };



  const MPNColumn: AgColDefsI = {
    headerName: HeaderName.MPN,
    field: "mpn",
    sortable: true,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    editable:false,
    minWidth: 100,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};



  const ReasonColumn: AgColDefsI = {
    headerName: HeaderName.REASON,
    field: "Reason",
    sortable: true,
    flex: 1,
    cellClass: "custom-part-number-cell",
    editable: false,
    minWidth: 100,
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
  };


  const AllocatedQtyColumn: AgColDefsI = {
    headerName: HeaderName.ALLOCATED_QTY,
    field: "AllocatedQty",
    sortable: true,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    suppressMovable: false,
    lockPinned: true,
    lockPosition: "left",
    minWidth: 170,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    headerClass:"checkbox-pl-0",
    editable:false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
    
};


  const SONoColumn: AgColDefsI = {
    headerName: HeaderName.SO_NO,
    field: "SONo",
    flex:1,
    cellClass: "custom-part-number-cell" ,
    sortable: true,
    editable: false,
    minWidth: 90,
    cellClassRules: {
      'text-semi-primary text-underline': (params) => params?.context?.storageName === GridName.ALLOCATION,
    },
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
  };



  const CustomerColumn: AgColDefsI = {
    headerName: HeaderName.CUSTOMER,
    field: "company",
    flex:1,
    cellClass: "custom-part-number-cell",
    sortable: true,
    editable: false,
    minWidth: 110,
    cellClassRules: {
      'text-semi-primary text-underline': (params) => params?.context?.storageName === GridName.ALLOCATION
    },
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",


};


  const ContactColumn: AgColDefsI = {
    headerName: HeaderName.CONTACT,
    field: "contact",
    flex:1,
    cellClass: "custom-part-number-cell",
    sortable: true,
    editable: false,
    minWidth: 110,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
const CompanyNameColumn: AgColDefsI = {
  headerName: HeaderName.COMPANYNAME,
  field: "company",
  headerCheckboxSelection: true,
  checkboxSelection: true,
  sortable: true,
  flex:1,
  cellClass: "custom-part-number-cell" ,
  lockPinned: true,
  editable:false,
  suppressMovable: false,
  lockPosition: "left",
  minWidth: 190,
  headerClass:"checkbox-pl-0",
  uniqueName:'workOrdercompanyName',
  cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};
const WorkOrderIDColumn: AgColDefsI = {
  headerName: HeaderName.WORKORDERID,
  field: "workorder",
  flex:1,
  cellClass: "custom-part-number-cell" ,
  sortable: true,
  editable: false,
  minWidth: 130,
  cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
};
const StatusIDColumn: AgColDefsI = {
  headerName: HeaderName.STATUSID,
  field: "statusid",
  flex:1,
  cellClass: "custom-part-number-cell" ,
  sortable: true,
  editable: false,
  minWidth: 120,
  cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",

};
const StatusNameColumn: AgColDefsI = {
  headerName: HeaderName.STATUSNAME,
  field: "statusname",
  flex:1,
  cellClass: "custom-part-number-cell" ,
  sortable: true,
  editable: false,
  minWidth: 120,
  cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",

};
const CompanyIDColumn: AgColDefsI = {
  headerName: HeaderName.COMPANYID,
  field: "companyid",
  flex:1,
  cellClass: "custom-part-number-cell" ,
  sortable: true,
editable:false,
minWidth: 120,
cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",

};
const CustomerIDColumn: AgColDefsI = {
  headerName: HeaderName.CUSTOMERID,
  field: "customerid",
  flex:1,
  cellClass: "custom-part-number-cell" ,
  sortable: true,
  editable: false,
  minWidth: 140,
  cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
};
const EventColumn: AgColDefsI = {
  headerName: HeaderName.EVENT,
  field: "message",
  flex:1,
  cellClass: "custom-part-number-cell text-primary-color" ,
  sortable: true,
  editable:false,
  minWidth: 120,
 cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
 uniqueName: "historyMessage"
};
const ActionColumn: AgColDefsI = {
  headerName: HeaderName.ACTION,
  field: "action",
  flex:1,
  cellClass: "custom-part-number-cell" ,
  sortable: true,
  editable:false,
 minWidth: 140,
 cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
 uniqueName: "Action"
};
const ByColumn: AgColDefsI = {
  headerName: HeaderName.BY,
  field: "createdBy",
  flex:1,
  cellClass: "custom-part-number-cell" ,
  sortable: true,
  editable:false,
  minWidth: 70,
 cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
 uniqueName: "By"
};
const TimeColumn: AgColDefsI = {
  headerName: HeaderName.TIME,
  field: "createdTime",
  flex:1,
  cellClass: "custom-part-number-cell" ,
  sortable: true,
  editable:false,
  minWidth: 90,
  cellRenderer: (params) => {
    if (!params.value) {
      return '<p>&#8212;</p>';
    }
    return convertUtcToIst(params.value);
  },
};
function convertUtcToIst(utcTime: string): string {
  if (!utcTime) return "--";
  const [hours, minutes, seconds] = utcTime.split(":").map(Number);
  const utcDate = new Date(Date.UTC(1970, 0, 1, hours, minutes, seconds));
  const istDate = new Date(utcDate.getTime() + (5.5 * 60 * 60 * 1000));
  const localHours = istDate.getUTCHours();
  const localMinutes = istDate.getUTCMinutes();
  const period = localHours >= 12 ? "PM" : "AM";
  const formattedHours = localHours % 12 || 12;
  return `${formattedHours}:${localMinutes.toString().padStart(2, '0')} ${period}`;
}

const DateColumn: AgColDefsI = {
  headerName: HeaderName.DATE,
  field: "createdAt",
  flex:1,
  cellClass: "custom-part-number-cell" ,
  sortable: true,
  editable:false,
  minWidth : 100,
  cellRenderer: (params) => {
  if (!params.value) {
    return "<p>&#8212;</p>";
  }
  const [month, day, year] = params.value.split("/");
  return `${day}/${month}/${year}`;
}
};
  const InvoiceNoColumn: AgColDefsI = {
    headerName: HeaderName.INVOICE,
    field: "invoice",
    flex:1,
    cellClass: "custom-part-number-cell" ,
    sortable: true,
    editable: false,
    minWidth: 100,
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
};


  const CustomerPOColumn: AgColDefsI = {
    headerName: HeaderName.CUSTOMER_PO,
    field: "customerPO",
    flex:1,
    cellClass: "custom-part-number-cell" ,
    sortable: true,
    editable: false,
    minWidth: 110,
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
};




  const WarehouseColumn: AgColDefsI = {
    headerName: HeaderName.WAREHOUSE,
    field: "Warehouse",
    sortable: true,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    editable: false,
    minWidth: 110,
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
  };



  const LocationColumn: AgColDefsI = {
    headerName: HeaderName.LOCATION,
    field: "Location",
    sortable: true,
    flex:1,
    cellClass: "custom-part-number-cell" ,
    resizable: false,
    editable: false,
    minWidth: 110,
    cellRenderer: params => params.value ? params.value : "<p>&#8212;</p>",
  };


  const ConsignedQtyColumn: AgColDefsI = {
    headerName: HeaderName.CONISIGNED_QTY,
    field: "consignedQty",
    sortable: true,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    suppressMovable: false,
    lockPinned: true,
    lockPosition: "left",
    minWidth: 170,
    flex:1,
    headerClass:"checkbox-pl-0",
    cellClass: "custom-part-number-cell" ,
    editable:false,
    cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};



  const ConsignorColumn: AgColDefsI = {
    headerName: HeaderName.CONSIGNOR,
    field: "consignor",
    sortable: true,
    flex:1,
    cellClass: "custom-part-number-cell" ,
  editable:false,
  minWidth: 150,
  cellRenderer: params => params.value ?params.value : "<p>&#8212;</p>",
};

const FileNameColumn: AgColDefsI = {
  headerName: DocumentTabHeader.FILE_NAME,
  field: "fileName",
  sortable: true,
  headerCheckboxSelection: true,
  checkboxSelection: true,
  headerClass: "ps-19",
  suppressMovable: false,
  cellClass: "custom-part-number-cell text-primary-color",
  lockPinned: true,
  lockPosition: "left",
  editable :false,
  minWidth: 170,
  flex:1,
 // cellRenderer: DocumentCellRendererComponent
 uniqueName:'files',
 cellRenderer: params => params.value ?params.value : "&#8212;",
};

const TypeColumn: AgColDefsI = {
  headerName: DocumentTabHeader.FILE_TYPE,
  field: "type",
  sortable: true,
  cellClass: "custom-part-number-cell",
  minWidth: 115,
  editable :false,
  flex:1,
  cellRenderer: params => params.value ?params.value : "&#8212;",
};
const SizeColumn: AgColDefsI = {
  headerName: DocumentTabHeader.SIZE,
  field: "sizes",
  sortable: true,
  minWidth: 110,
  editable :false,
  flex:1,
  cellClass: "custom-part-number-cell",
  cellRenderer: params => params.value ?params.value : "&#8212;",
};
const CategoryColumn: AgColDefsI = {
  headerName: DocumentTabHeader.CATEGORY,
  field: "categoryName",
  sortable: true,
  minWidth: 140,
  flex:1,
  editable :false,
  cellClass: "custom-part-number-cell",
  cellRenderer: DocumentCellRendererComponent,
  
};
const SourceColumn: AgColDefsI = {
  headerName: DocumentTabHeader.SOURCE,
  field: "sourceName",
  sortable: true,
  minWidth: 120,
  editable :false,
  flex:1,
  cellClass: "custom-part-number-cell",
  cellRenderer: params => params.value ?params.value : "&#8212;",
};
const DateUpdatedColumn: AgColDefsI = {
  headerName: DocumentTabHeader.DATE_UPLOADED,
  field: "createdAt",
  sortable: true,
  editable :false,
  minWidth: 175,
  flex:1,
  cellClass: "custom-part-number-cell",
  cellRenderer: params => {
    if (!params.value) {
      return "&#8212;";
    }
    const date = new Date(params.value);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    return formattedDate; 
  },
};
const DownloadColumn: AgColDefsI = {
  headerName: "",
  field: "download",
  editable :false,
  flex:1,
  minWidth: 220,
  lockPosition:'right',
  cellStyle: {'color': '#646E76' },
  cellRenderer:DocumentCellRendererComponent,
  cellRendererParams:{download:'download',preview:'preview' ,lineInformation:true}
};
const COOColumn: AgColDefsI = {
  headerName: 'COO',
  field: "coo",
  flex:1,
  sortable: true,
  cellClass: "custom-part-number-cell",
editable:false,
minWidth: 120,
cellRenderer: CompanyRendererComponent,
cellRendererParams: (params: any) => {
  const list = (params.value || "").split(",").map(item => item.trim()).filter(item => item)
  const dataToShow = list.length > 2
    ? `${list.slice(0, 2).join(", ")} +${list.length - 2}`
    : list.join(", ") || "—";

  return {
    isTooltipEnabled: true,
    dataToShow, 
    tooltipData: list.join(", ") || "—",
  };
},

};




  export const ColDefsConsignment: AgColDefsI[] = [
    ConsignedQtyColumn,
    AvailableColumn,
    MPNColumn,
    MFRColumn,
    SplitDateCodeColumn,
    LotCodeColumn,
    SPQColumn,
    ItemPkgColumn,
    RoHSColumn,
    ConsignorColumn,
  ];
  
  export const AgGridDataModelConsignment: AgGridI = {
    colDefs: ColDefsConsignment ,
    storageName : GridName.CONSIGNMENT,
    rowSelection: "multiple",
   };


  export const ColDefsAllocation: AgColDefsI[] = [
    AllocatedQtyColumn,
    DateCodeColumn,
    LotCodeColumn,
    RoHSColumn,
    ConditionColumn,
    SONoColumn,
    CustomerColumn,
    WarehouseColumn,
    LocationColumn
  ];
  
  export const AgGridDataModelAllocation: AgGridI = {
    colDefs: ColDefsAllocation,
    storageName : GridName.ALLOCATION,
    rowSelection: "multiple",
   };



  export const ColDefsQuarantine: AgColDefsI[] = [
    StatusColumn,
    ReasonColumn,
    MPNColumn,
    MFRColumn,
    QtyColumn,
    DateCodeColumn,
    LotCodeColumn,
    ConditionColumn,
    NCMColumn,
    WONoColumn,
  ];
  
  
  export const AgGridDataModelQuarantine: AgGridI = {
    colDefs: ColDefsQuarantine ,
    rowSelection: "multiple",
    storageName : GridName.QUARANTINE,
   };



  export const ColDefsInstock: AgColDefsI[] = [
    PartNumberColumn,
    MfrColumn,
    OnHandColumn,
    AvailableColumn,
    SplitDateCodeColumn,
    LotCodeColumn,
    SPQColumn,
    ItemPkgColumn,
    RoHSColumn,
    VendorColumn,
  ];
  
  export const AgGridDataModelInstock: AgGridI = {
    colDefs: ColDefsInstock,
    storageName : GridName.INSTOCK,
    rowSelection: "multiple",
  };




  export const ColDefsPending: AgColDefsI[] = [
    StatusColumn,
    WONoColumn,
    TesthouseColumn,
    QtyColumn,
    MPNColumn,
    MFRColumn,
    DateCodeColumn,
    LotCodeColumn,
    ConditionColumn,
    VendorColumn,
  ];
  
  export const AgGridDataModelPending: AgGridI = {
    colDefs: ColDefsPending,
    rowSelection: "multiple",
    storageName : GridName.PENDING,
  };


  export const ColDefsSold: AgColDefsI[] = [
    StatusColumn,
    MPNColumn,
    MFRColumn,
    QtyColumn,
    DateCodeColumn,
    LotCodeColumn,
    ConditionColumn,
    NCMColumn,
    WONoColumn,
    CustomerColumn,
    ContactColumn,
    SONoColumn,
    InvoiceNoColumn,
    CustomerPOColumn
  ];
  
  
  export const AgGridDataModelSold: AgGridI = {
    colDefs: ColDefsSold,
    rowSelection: "multiple",
    storageName : GridName.SOLD,
   };
  export const ColDefsOEMExcess: AgColDefsI[] = [
    ListDateColumn,
    MPNColumn,
    MFRColumn,
    CPNColumn,
    CustomerColumn,
    CustomerContactColumn,
    RecordTypeColumn,
    QtyAvailableColumn,
    PriceColumn,
    ExpirationDateColumn,
    RohsColumn,
    ConditionColumn,
    RatingColumn,
    ActiveColumn
  ];
  

  export const AgGridDataModelOemExcess: AgGridI = {
    colDefs: ColDefsOEMExcess,
    storageName : GridName.OEM_EXCESS,
    rowSelection: "multiple",
  };
  export const ColDefsVendorParts: AgColDefsI[] = [
    ListDateColumn,
    MPNColumn,
    MFRColumn,
    VendorColumn,
    VendorContactColumn,
    RecordTypeColumn,
    QtyAvailableColumn,
    PriceColumn,
    ExpirationDateColumn,
    RohsColumn,
    ConditionColumn,
    RatingColumn,
    ActiveColumn
  ];
  

  export const AgGridDataModelVendorParts: AgGridI = {
    colDefs: ColDefsVendorParts,
    storageName : GridName.VENDOR_PARTS,
    rowSelection: "multiple",
  };
  export const ColDefsVendorPartsList: AgColDefsI[] = [
    ListDateColumn,
    MPNColumn,
    MFRColumn,
    QtyColumn,
    DateCodeColumn,
    RohSColumn,
    ConditionColumn,
    RecordTypeColumn,
  ];
  

  export const AgGridDataModelVendorPartsList: AgGridI = {
    colDefs: ColDefsVendorPartsList,
    storageName : GridName.VENDOR_PARTS_LIST,
    rowSelection: "multiple",
  };

  export const ColDefsAlternatives: AgColDefsI[] = [
   MPNAlternativeColumn,
   ManufacturerColumn,
   DescriptionColumn,
   PartStatusColumn,
   ROHSColumn,
   TagsColumn,
   SPQColumn,
   DevicePkgColumn,
   StandardPkgColumn,
   COOColumn,
   NotesColumn,
   LinkColumn
  ];
  

  export const AgGridDataModelAlternatives: AgGridI = {
    colDefs: ColDefsAlternatives,
    storageName : GridName.ALTERNATIVES,
    rowSelection: "multiple",
  };

  export const ColDefsRequirement: AgColDefsI[] = [
    CompanyColumn,
    StatusWithoutCheckboxColumn,
    RequestColumn,
    BuyTargetColumn,
    TargetPriceColumn,
    QtyColumn,
    ContactColumn
  ];
  
  export const AgGridDataModelRequirement: AgGridI = {
    colDefs: ColDefsRequirement,
    storageName : GridName.REQUIREMNT,
    rowSelection: "multiple",
  };
  export const ColDefsWorkOrder: AgColDefsI[] = [
    CompanyNameColumn,
    WorkOrderIDColumn,
    StatusIDColumn,
    StatusNameColumn,
    CompanyIDColumn,
    CustomerIDColumn,
  ];
  
  export const AgGridDataModelWorkOrder: AgGridI = {
    colDefs: ColDefsWorkOrder,
    storageName : GridName.WORKORDER,
    rowSelection: "multiple",
  };
  export const ColDefsHistory: AgColDefsI[] = [
    EventColumn,
    ActionColumn,
    ByColumn,
    TimeColumn,
    DateColumn,
  ];
  
  export const AgGridDataModelHistory: AgGridI = {
    colDefs: ColDefsHistory,
    storageName : GridName.HISTORY,
    rowSelection: "multiple",
  };
  export const ColDefsDocuments: AgColDefsI[] = [
    FileNameColumn,
    TypeColumn,
    SizeColumn,
    CategoryColumn,
    SourceColumn,
    DateUpdatedColumn,
    DownloadColumn,
  
  ];
  
  export const agGridDataModelDocuments: AgGridI = {
    colDefs: ColDefsDocuments,
    storageName : GridName.FILES,
    rowSelection: "multiple",
  };
  export const ColDefsImages: AgColDefsI[] = [
    FileNameColumn,
    TypeColumn,
    SizeColumn,
    DateUpdatedColumn,
    DownloadColumn,
  ];
  
  export const agGridDataModelImages: AgGridI = {
    colDefs: ColDefsImages,
    storageName : GridName.IMAGES,
    rowSelection: "multiple",
  };

   